import { Injectable } from '@angular/core';

const HISTORY_STORAGE_KEY = 'globalSearchHistory';
const MAX_HISTORY_ITEMS = 10;

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchHistoryService {

  constructor() { }

  /**
   * Add a search query to the history
   * Maintains only the last 10 items, removing duplicates
   */
  addToHistory(searchQuery: string): void {
    if (!searchQuery || searchQuery.trim().length < 3) {
      return; // Don't store searches with less than 3 characters
    }

    let history = this.getHistory();

    // Remove if already exists (to avoid duplicates)
    history = history.filter(item => item.toLowerCase() !== searchQuery.toLowerCase());

    // Add to the beginning
    history.unshift(searchQuery.trim());

    // Keep only the last 10 items
    if (history.length > MAX_HISTORY_ITEMS) {
      history = history.slice(0, MAX_HISTORY_ITEMS);
    }

    // Save to localStorage
    localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(history));
  }

  /**
   * Get the search history from localStorage
   */
  getHistory(): string[] {
    try {
      const historyJson = localStorage.getItem(HISTORY_STORAGE_KEY);
      if (historyJson) {
        return JSON.parse(historyJson);
      }
    } catch (error) {
      console.error('Error reading global search history from localStorage:', error);
    }
    return [];
  }

  /**
   * Clear the search history
   */
  clearHistory(): void {
    localStorage.removeItem(HISTORY_STORAGE_KEY);
  }
}

